import { useContext } from "react"
import { UploadDocumentsContext } from "../UploadDocuments"
import { Button, OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import { Trash } from "react-feather"



export default function DocumentTable (){

    const {
        invoiceData,
        notyf,

        canDelete,

        deleteModalLogic,
    } = useContext(UploadDocumentsContext) ?? {}

    return (
        <Table fluid striped bordered hover>
            <thead>
                <tr style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                }}>
                    <th>#</th>
                    <th>File Name</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {invoiceData?.table?.map((data, index) => (
                    <tr>
                        <td>{index + 1}</td>
                        <td><a href={data?.full_path} target="_blank">{data?.file_name}</a></td>
                        <td width={10}>
                            <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Delete</Tooltip>}
                            >
                                <Trash
                                    style={{ cursor: "pointer" }}
                                    size="20"
                                    onClick={() => canDelete ? 
                                        deleteModalLogic?.toggleModalAndBind(data?.id) : 
                                        notyf?.error('You do not have permission to do this action')
                                    }
                                    color="red"
                                />
                            </OverlayTrigger>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )   
} 